import { getFormattedDate } from '@natu/utils/getFormattedDate';

export const getDateAndReadTime = (date?: string | null, readTime?: string | null): string => `
    ${date ? getFormattedDate(date, 'MMMM dd, yyyy') : ''}
    ${date && readTime ? '•' : ''}
    ${readTime ? `${readTime} min read` : ''}
  `;
